import { setAccessTokenProvider } from '../../../apis/tempMee';
import { createSessionStore } from './createSessionStore';

/**
 * The app's session, and the access token every request through
 * `apis/tempMee` carries. See `createSessionStore` for how it behaves.
 */
export const sessionStore = createSessionStore();

setAccessTokenProvider(sessionStore.getAccessToken);
